import { useQuery } from "react-query";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getRealtime } from "../api/contest";
import * as Sentry from '@sentry/react';

const useRealtime = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  const branch_id = searchParams.get('branch_id');
  const token = searchParams.get('token');

  const result = useQuery(["realtime", id, branch_id], async () => {
    if (token && branch_id) {
      const res = await getRealtime({ branch_id, token });
      return res.data;
    }
    if (id && branch_id) {
      const res = await getRealtime({ id, branch_id });
      return res.data;
    } else {
      Sentry.captureMessage(`Please enter valid url. [lack-token-or-branch-id] [token=${id}] [branch_id=${branch_id}]`);
      toast.warn("Please enter valid url.");
    }
    return null;
  }, {
    onError: (err: any) => {
      Sentry.captureException(err);
      toast.warn(err.message);
    },
    refetchInterval: 5*1000,
  });

  return result;
}

export default useRealtime;